import { Badge } from '@/shared/ui/Badge'

/**
 * Networking tags the partner declared, shown on the premium profile (handoff
 * bloco 6). Purely informational for the participant; the matchmaking engine is
 * a separate feature. Omitted when the partner has no tags.
 */
export const PartnerTags = ({ tags = [] }) => {
  if (!tags.length) return null

  return (
    <section>
      <h2 className="m-0 text-[15px] font-bold text-gray-900">Interesses deste parceiro</h2>
      <p className="mt-0.5 mb-0 text-[13px] text-gray-700">
        Temas que eles querem conversar no evento
      </p>
      <div className="mt-2.5 flex flex-wrap gap-2">
        {tags.map(tag => (
          <Badge key={tag.id} variant="available" tone="light" size="sm" showIcon={false}>
            {tag.name}
          </Badge>
        ))}
      </div>
    </section>
  )
}
